var _circle, _g, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 122,
    viewBox: "0 0 122 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1155_1740",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 122,
    height: 122
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61,
    r: 61,
    fill: "#F5F7F9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1155_1740)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 61.1641,
    r: 61,
    fill: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4 82.1655V67.9655C38.4 65.9655 38.6 63.9655 39.1 62.0655L42.8 47.1655C43.1 45.9655 44.2 45.0655 45.5 45.0655C47 45.0655 48.3 46.2655 48.3 47.8655V62.4655L68.2 33.6655C69.4 31.8655 72 31.6655 73.5 33.1655C74.7 34.3655 74.9 36.1655 73.9 37.5655L60.6 57.4655L77.9 35.7655C79.2 34.0655 81.7 33.9655 83.2 35.4655C84.4 36.6655 84.6 38.6655 83.6 40.0655L65.6 64.8655L83.6 43.6655C84.6 42.4655 86.4 42.2655 87.7 43.1655C89.1 44.1655 89.4 46.2655 88.3 47.5655L70.5 69.7655L82.0049 58.1368C86.4812 53.6123 90.7909 54.5028 87.7 60.0664V60.0664L76.9 74.8655C75.9 76.4655 74.9 77.9655 73.7 79.3655L60.6 94.5655L50.7 121.865H21L38.4 82.1655Z",
    fill: "#FFB0AC"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 54.295,
    y1: 22.1098,
    x2: 48.9458,
    y2: 15.8691,
    stroke: "#0A66BE",
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 47.8459,
    y1: 33.8489,
    x2: 40.3488,
    y2: 31.7791,
    stroke: "#0A66BE",
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 49.8834,
    y1: 27.4137,
    x2: 42.1755,
    y2: 22.8491,
    stroke: "#0A66BE",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default __webpack_public_path__ + "static/media/wave.86fd87e9e9616d042ad8df3dbefc9e34.svg";
export { ForwardRef as ReactComponent };